var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWabi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.98 16 6.162 6.162L21.304 16l-6.162-6.162L8.98 16zm-6.166-1.814a2.565 2.565 0 0 0 0 3.628l10.515 10.515a2.565 2.565 0 0 0 3.626-.001L27.47 17.812a2.565 2.565 0 0 0 0-3.628L16.957 3.672a2.565 2.565 0 0 0-3.627 0L2.812 14.186z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWabi);
export default __webpack_public_path__ + "static/media/WABI.ba49c17db197da1f974fdb2be2eddc1f.svg";
export { ForwardRef as ReactComponent };